// extracted by mini-css-extract-plugin
export default {"numberKeyboard":"NumberKeyboard_numberKeyboard__+FYz2"};